<template>
  <div class="calico-progress-bar-page">
    <div class="calico-progress-bar-container">
      <div class="calico-progress-bar-row">
        <CalicoProgressBar
          :current="1"
          :steps="steps1"
        />
      </div>
      <div class="calico-progress-bar-row">
        <CalicoProgressBar
          :current="2"
          :steps="steps2"
        />
      </div>
      <div class="calico-progress-bar-row">
        <CalicoProgressBar
          :current="3"
          :steps="steps3"
        />
      </div>
      <div class="calico-progress-bar-row">
        <CalicoProgressBar
          :current="6"
          :steps="steps"
        />
      </div>
    </div>
  </div>
</template>

<script lang="js">
import CalicoProgressBar from '@/components/pattern/progressBar/index.vue'
export default {
  name: 'CalicoProgressBarPage',
  components: {
    CalicoProgressBar
  },
  data () {
    return {
      steps1: [{
        name: 'Dashboard'
      }, {
        name: 'Step 1',
        complete: false,
        timestamp: new Date()
      }, {
        name: 'Step 2',
        complete: false,
        timestamp: new Date()
      }],
      steps2: [{
        name: 'Dashboard'
      }, {
        name: 'Step 1',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 2',
        complete: false,
        timestamp: new Date()
      }, {
        name: 'Step 3',
        complete: false,
        timestamp: new Date()
      }],
      steps3: [{
        name: 'Dashboard'
      }, {
        name: 'Step 1',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 2',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 3',
        complete: false,
        timestamp: new Date()
      }, {
        name: 'Step 4',
        complete: false,
        timestamp: new Date()
      }],
      steps: [{
        name: 'Dashboard'
      }, {
        name: 'Step 1',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 2',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 3',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 4',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 5',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 6',
        complete: true,
        timestamp: new Date()
      }, {
        name: 'Step 7',
        complete: false,
        timestamp: new Date()
      }]
    }
  }
}
</script>
<style lang="scss">
.calico-progress-bar-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-progress-bar-container {
    display: flex;
    flex-direction: column;
    @include inset-space($space-large);
    width: 100%;
    .calico-progress-bar-row {
      width: 100%;
      @include inline-space($space-large);
      @include inset-space($space-large);
    }
  }
}
</style>
